module.exports = __webpack_public_path__ + "static/media/eu.551738bd.svg";